import { useEffect, useState } from "react";
import Select, { components } from "react-select";

export const categoriaOptions = [
  { value: "asociado", label: "Asociado" },
  { value: "cobertura", label: "Cobertura" },
  { value: "solicitud", label: "Solicitud" },
  { value: "prestacion", label: "Prestación" },
  { value: "prestador", label: "Prestador" },
  { value: "prescriptor", label: "Prescriptor" },
  { value: "convenio", label: "Convenio" },
  { value: "consumo", label: "Consumo" },
  { value: "sistema", label: "Sistema" },
];

export const atributosPorCategoria = {
  asociado: [
    { value: "edad", label: "Edad" },
    { value: "diagnostico", label: "Diagnostico", isDisabled: true },
    { value: "antiguedad", label: "Antigüedad", isDisabled: true },
    { value: "nivelMorosidad", label: "Nivel de Morosidad"},
    { value: "corporacion", label: "Corporación", isDisabled: true },
    { value: "nroAsociado", label: "Número de Asociado", isDisabled: true },
    { value: "activo", label: "Activo"},
    { value: "condicionMedica", label: "Condicion Medica" }
  ],
  cobertura: [
    { value: "planAsignado", label: "Plan Asignado", isDisabled: true },
    { value: "estado", label: "Estado", isDisabled: true },
    { value: "beneficios", label: "Beneficios Adicionales", isDisabled: true },
    { value: "especialidad", label: "Especialidad", isDisabled: true },
    { value: "coberturaPorcentaje", label: "Cobertura Porcentaje (Medicamentos)" }
  ],
  solicitud: [
    { value: "fecha", label: "Fecha de Solicitud"},
    { value: "canalIngreso", label: "Canal de Ingreso", isDisabled: true },
    { value: "estadoActual", label: "Estado Actual"},
    { value: "cantidad", label: "Cantidad Solicitada", isDisabled: true },
    { value: "ambito", label: "Ambito"}
  ],
  prestacion: [
    { value: "tipo", label: "Tipo", isDisabled: true },
    { value: "nombre", label: "Nombre", isDisabled: true },
    { value: 'prerequisitos', label: 'Requisitos' },
    { value: "familia", label: "Familia Prestaciones", isDisabled: true }
  ],
  prestador: [
    { value: "prestador", label: "Prestador", isDisabled: true },
    { value: "tipoOrganizacion", label: "Tipo de Organización", isDisabled: true },
    { value: "region", label: "Región", isDisabled: true },
    { value: "cuit", label: "CUIT", isDisabled: true },
    { value: "consultorio", label: "Consultorio", isDisabled: true }
  ],
  prescriptor: [
    { value: "prescriptor", label: "Prescriptor", isDisabled: true },
    { value: "region", label: "Región", isDisabled: true },
    { value: "especialidad", label: "Especialidad", isDisabled: true }
  ],
  convenio: [
    { value: "tipo", label: "Tipo Global", isDisabled: true },
    { value: "tipo", label: "Tipo Individual", isDisabled: true },
    { value: "vigencia", label: "Vigencia Activa", isDisabled: true },
    { value: "region", label: "Región", isDisabled: true }
  ],
  consumo: [
    { value: "topeMensual", label: "Tope Mensual" },
    { value: "topeAnual", label: "Tope Anual"},
    { value: "topeGeneral", label: "Tope General"}
  ],
  sistema: [
    { value: "fecha", label: "Fecha Actual", isDisabled: true },
    { value: "diaSemana", label: "Día de la Semana", isDisabled: true },
    { value: "hora", label: "Hora Actual", isDisabled: true }
  ]
};

const SelectAtributo = ({
  value,
  onChange,
  customStyles,
  disablePrerequisitos = false,
  tipoReglaCodigo = "PRESTACION"
}) => {
  const esTipoPrestacion = String(tipoReglaCodigo || "").toUpperCase() === "PRESTACION";
  const [nivel, setNivel] = useState("categorias");
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setNivel("categorias");
    setCategoriaSeleccionada(null);
  }, [esTipoPrestacion]);

  const opcionesBase =
      nivel === "categorias"
          ? categoriaOptions
          : atributosPorCategoria[categoriaSeleccionada?.value];


  // ✅ Si ya existe condición "prerequisitos", deshabilitar esa opción en la categoría prestación
  const opciones = (opcionesBase || []).map((opt) => {
    if (String(tipoReglaCodigo || "").toUpperCase() === "PRESTACION") {
      return { ...opt, isDisabled: false };
    }
    if (opt.value === "prerequisitos" && disablePrerequisitos) {
      return { ...opt, isDisabled: true };
    }
    return opt;
  });

  const MenuList = (props) => (
      <components.MenuList {...props}>
        {nivel === "atributos" && (
            <div
                style={{ padding: "8px 10px", fontWeight: 600, cursor: "pointer" }}
                onClick={() => setNivel("categorias")}
            >
              ← Volver
            </div>
        )}
        {props.children}
      </components.MenuList>
  );

  const handleChange = (option) => {
    if (nivel === "categorias") {
      setCategoriaSeleccionada(option);
      setNivel("atributos");
      return;
    }

    onChange(option);
    setMenuOpen(false);
    setNivel("categorias");
    setCategoriaSeleccionada(null);
  };

  const handleMenuClose = () => {
    setMenuOpen(false);
    setNivel("categorias");
    setCategoriaSeleccionada(null);
  };

  const handleMenuOpen = () => {
    setNivel("categorias");
    setCategoriaSeleccionada(null);
    setMenuOpen(true);
  };

  return (
      <Select
          options={opciones}
          value={value}
          onChange={handleChange}
          placeholder="Seleccionar…"
          components={{ MenuList }}
          // ✅ respeta disabled de cada opción (incluye prerequisitos cuando ya existe)
          isOptionDisabled={(opt) => !!opt.isDisabled}
          styles={customStyles}
          closeMenuOnSelect={false}
          menuIsOpen={menuOpen}
          onMenuOpen={handleMenuOpen}
          onMenuClose={handleMenuClose}
      />
  );
};

export default SelectAtributo;
